if (document.documentElement.clientWidth < 750) {
  if (document.querySelector(".collapsible-shipping-content-new-container")) {
    let pcWrapper = document.querySelector(".collapsible-shipping_wrapper")
    document.querySelector(".collapsible-shipping-content-new-container").querySelector(".collapsible-content-new-top").querySelector("div").innerHTML = pcWrapper.querySelector(".disclosure__title").innerHTML
    pcWrapper.querySelector(".disclosure__title").innerHTML = ''
  }
}
window.addEventListener("load",function(){

  let document_width = document.documentElement.clientWidth
  $(".custom_collection_tab_title").click(function() {
    let flag = true
    if(!$(this).hasClass("active") && flag){
      flag = false
      let index = $(this).index()
      let class_id = $(this).data("initid")
      let pc_num = $(this).data("num") || 4
      $(this).siblings(".custom_collection_tab_title").removeClass("active")
      $(this).addClass("active")
      if ($(this).data("link")) {
        $(this).parents(".container").find(".section__header").find(".custom_collection_link").attr("href",$(this).data("link"))
      }
      $(this).parents(".custom_collection_tab_container").find(".custom_collection_tab_content_list").find(".custom_collection_tab_content").hide()
          $(this).parents(".custom_collection_tab_container").find(".custom_collection_tab_content_list").find(".custom_collection_tab_content").eq(index).fadeIn(function() {
          initializeSwiper(class_id,pc_num)
        })
    }
  })
  $(".custom-halloween-card-view-more").click(function() {
      if (document_width > 750) {
      $(this).parents(".container").find(".custom-halloween-card-hidden-pc").removeClass("custom-halloween-card-hidden-pc")
      }else{
      $(this).parents(".container").find(".custom-halloween-card-hidden-m").removeClass("custom-halloween-card-hidden-m")
      }
    $(this).fadeOut()
  })
  $(".menu-drawer__navigation_left_item").click(function() {
    if (!$(this).hasClass("active")) {
      let index = $(this).index()
      $(this).siblings(".menu-drawer__navigation_left_item").removeClass("active")
      $(this).addClass("active")
      $(this).parents(".menu-drawer__navigation_new").find(".menu-drawer__navigation_right").find(".menu-drawer__navigation_content").removeClass("active")
      $(this).parents(".menu-drawer__navigation_new").find(".menu-drawer__navigation_right").find(".menu-drawer__navigation_content").eq(index).addClass("active")
    }
  })


  $(".js_copy").click(function() {
    if (!$(this).hasClass("copied")) {
     var $temp = $("<input>");
      $("body").append($temp);
      $temp.val($(this).data("code")).select();
      document.execCommand("copy");
      $temp.remove();
      $(this).parents(".custom_discount_code_list").find(".js_copy").removeClass("copied")
      $(this).parents(".custom_discount_code_list").find(".js_copy").text("Copy Code")
      $(this).addClass("copied")
      $(this).text("Code Copied")
    }
  })

    $(".custom_discount_auto_button").click(function() {
      $(this).addClass("is-loading")
      $(this).attr("disabled","disabled")
        $(".product-info").find(".product-info__add-button").find("button").click()      
    })
 
  $(".close_discount_pop").click(function() {
      $("body").removeClass("popshow")
      $("html").removeClass("popshow")
      if (document_width > 750) {
          $(this).parents(".custom_product_discount_pop_container").css({"transform": "translate(100%)"})
      }else{
        $(this).parents(".custom_product_discount_pop_container").css({"transform": "translateY(100%)"})
      }
    
      setTimeout(()=>{
       $(this).parents(".custom_product_discount_pop").fadeOut()
      },400)
  })
  $(".collapsible-content-new-wrapper").click(function(){
      $("body").addClass("popshow")
       $("html").addClass("popshow")
      let content = ''
    
      $(".disclosure__content_new").each((index,item)=>{
        content += `<div class="collapsible-content-new-pop-content">${item.innerHTML}</div>`
      })
    if ($(this).hasClass("collapsible-content-shipping")) {
      console.log($(this))
      let shippingContent = $(".collapsible-shipping_wrapper").find(".disclosure__content").html()
      console.log(shippingContent)
      $(this).parent().find(".custom_discount_pop_header").find("span").html($(this).find(".h6").html())
      $(this).parent().find(".collapsible-content-new-pop-content").html(shippingContent)
    }
    $(".collapsible-content-new-pop-wrapper").html(content)
      $(this).siblings(".collapsible-content-new-pop").fadeIn(function() {
         $(this).find(".collapsible-content-new-pop-container").css({"transform": "translateY(0)"})
      })
  })
  $(".close_collapsible_pop").click(function() {
      $("body").removeClass("popshow")
      $("html").removeClass("popshow")
        $(this).parents(".collapsible-content-new-pop-container").css({"transform": "translateY(100%)"})
      setTimeout(()=>{
       $(this).parents(".collapsible-content-new-pop").fadeOut()
    $(".collapsible-content-new-pop-wrapper").html('')
        
      },400)
  })
  $(".custom_term_service_list").click(function() {
     $("body").addClass("popshow")
       $("html").addClass("popshow")
      $(this).siblings(".custom_term_service_pop").fadeIn(function() {
          $(this).find(".custom_term_service_pop_container").css({"transform": "translate(0)"})
      })
  })
    $(".close_term_service_pop").click(function() {
     $("body").removeClass("popshow")
       $("html").removeClass("popshow")
        if (document_width > 750) {
            $(this).parents(".custom_term_service_pop_container").css({"transform": "translate(100%)"})
          }else{
            $(this).parents(".custom_term_service_pop_container").css({"transform": "translateY(100%)"})
          }
   setTimeout(()=>{
       $(this).parents(".custom_term_service_pop").fadeOut()
      },400)
  })
   $(".custom_card_new_show_more").click(function() {
    $(this).parent().find(".custom_card_new_container").find(".d-m-none").removeClass("d-m-none")
     $(this).hide()
  })
  if (document_width > 750) {
     $(".product_tab_item").click(function() {
      if (!$(this).hasClass("active")) {
        let index = $(this).index()
        let tab_size = 100 / $(this).parent().find(".product_tab_item").length
        $(this).siblings(".product_tab_item").removeClass("active")
        $(this).addClass("active")
        $(this).parents(".product_tab_section").find(".product_tab_container").find(".product_tab_content").hide()
        $(this).parents(".product_tab_section").find(".product_tab_container").find(".product_tab_content").eq(index).show()
        $(this).siblings(".custom_product_tab_line").find("div").css({"left":index*tab_size+"%"})
      }
    })
    
  }else{
     $(".product_tab_item").click(function() {
       $("body").addClass("popshow")
       $("html").addClass("popshow")
        let index = $(this).index()
          $(this).parents(".product_tab_section").find(".product_tab_container").find(".product_tab_content").hide()
        $(this).parents(".product_tab_section").find(".product_tab_container").find(".product_tab_content").eq(index).show()
      $(this).parents(".product_tab_section").find(".product_tab_container").show(function() {
  
       $(this).parents(".product_tab_section").find(".product_tab_container").find(".product_tab_container_box").css({"transform": "translateY(0)"})
      })
    })
    $(".js_close_product_tab_container").click(function(params) {
       $("body").removeClass("popshow")
       $("html").removeClass("popshow")
       $(this).parents(".product_tab_section").find(".product_tab_container").find(".product_tab_container_box").css({"transform": "translateY(100%)"})
        setTimeout(()=>{
         $(this).parents(".product_tab_section").find(".product_tab_container").hide()
        },400)
    })
  }
})
function changeVariantOptions(e) {
     let value = $(e).val()
    let controlId = $(e).data("control")
    $(e).parents(".option-selector").find(".option-selector__label-value").text(value)
    $(`#${controlId}`).val(value)
}

function initializeSwiper(class_name,pc_num) {
  
    new Swiper (`.custom_collection_tab_swiper_${class_name}`, {
          slidesPerView: "auto",
          spaceBetween: 10,
         freeMode: true,
          breakpoints: {
            750: {
              slidesPerView: pc_num,
          spaceBetween: 20,
              freeMode: false
            }
          },
          navigation: {
            nextEl: `.swiper-button-next_${class_name}`,
            prevEl: `.swiper-button-prev_${class_name}`,
          }
        })
}
  function open_custom_pop(t){
    $("body").addClass("popshow")
    $("html").addClass("popshow")
    if ($(t).find(".custom_product_discount_price")) {
      let price = $(t).find(".custom_product_discount_price").data("price")
      let nowPrice = $(t).find(".custom_product_discount_price").data("coupon")
      let diffPrice = $(t).find(".custom_product_discount_price").data("diff")
      let buttonStatus = $(t).find(".custom_product_discount_price").data("status")
      $(".custom_product_discount_pop").find(".custom_discount_auto_content").find(".custom_discount_auto_info_comprice").html(price)
      $(".custom_product_discount_pop").find(".custom_discount_auto_content").find(".custom_discount_auto_info_diffprice").html("-"+diffPrice)
      $(".custom_product_discount_pop").find(".custom_discount_auto_content").find(".custom_discount_pop_price").html(nowPrice)
      if (!buttonStatus) {
        $(".custom_product_discount_pop").find(".custom_discount_auto_content").find(".custom_discount_auto_button").find("span").html("Sold Out")
        $(".custom_product_discount_pop").find(".custom_discount_auto_content").find(".custom_discount_auto_button").attr("disabled","disabled")
      }else{
        $(".custom_product_discount_pop").find(".custom_discount_auto_content").find(".custom_discount_auto_button").find("span").html("Add To Cart")
      $(".custom_product_discount_pop").find(".custom_discount_auto_content").find(".custom_discount_auto_button").removeAttr("disabled")
      }
    }
   $(".custom_product_discount_pop").fadeIn(function() {
      $(this).find(".custom_product_discount_pop_container").css({"transform": "translate(0)"})
    })
  }
